import { render, staticRenderFns } from "./IndicesEstrategicosPorMunicipio.vue?vue&type=template&id=8777a252"
import script from "./IndicesEstrategicosPorMunicipio.vue?vue&type=script&lang=js"
export * from "./IndicesEstrategicosPorMunicipio.vue?vue&type=script&lang=js"
import style0 from "./IndicesEstrategicosPorMunicipio.vue?vue&type=style&index=0&id=8777a252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports